// src/pages/fourd/Project4DPage.jsx
import React, { useState } from "react";
import { useParams } from "react-router-dom";
// 기존 FourDList 대신 자료실 트리 사용
import FileTreePanel from "../../components/common/papers/FileTreePanel";
import ThreeViewerWithTimeline from "../../components/viewer/viewer3d/ThreeViewerWithTimeline";
import ThreeViewer from "../../components/viewer/viewer3d/ThreeViewer";

const Project4DPage = () => {
  const { id: projectId } = useParams();
  const [selectedFourD, setSelectedFourD] = useState(null); // { gltfUrl, name }
  const [viewMode, setViewMode] = useState("simulation"); // simulation | model

  return (
    <div className="p-6 bg-gray-50 min-h-[calc(100vh-64px)]">
      {/* 상단 헤더 */}
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900">4D 시뮬레이션 보기</h2>
        <p className="mt-1 text-sm text-gray-500">
          프로젝트 ID:{" "}
          <span className="font-medium text-gray-700">{projectId}</span>
        </p>
        <p className="mt-2 text-xs text-gray-500">
          자료실의 <span className="font-semibold">4DSimulation</span> 폴더
          하위에 업로드된 glTF 파일을 선택하여 4D/3D 모델을 확인할 수 있습니다.
        </p>
      </div>

      {/* 보기 모드 탭 + 설명 */}
      <div className="mb-5 flex items-center justify-between gap-4">
        {/* 탭 */}
        <div className="inline-flex rounded-full bg-gray-200 p-1">
          <button
            type="button"
            className={`px-4 py-2 text-sm font-medium rounded-full transition
              ${
                viewMode === "simulation"
                  ? "bg-white shadow-sm text-blue-600"
                  : "text-gray-600"
              }`}
            onClick={() => setViewMode("simulation")}
          >
            시뮬레이션 보기
          </button>
          <button
            type="button"
            className={`px-4 py-2 text-sm font-medium rounded-full transition
              ${
                viewMode === "model"
                  ? "bg-white shadow-sm text-blue-600"
                  : "text-gray-600"
              }`}
            onClick={() => setViewMode("model")}
          >
            모델만 보기
          </button>
        </div>

        <div className="hidden md:block text-xs text-gray-500">
          시뮬레이션 보기에서는 타임라인과 공정 상태를 함께 확인할 수 있습니다.
        </div>
      </div>

      {/* 메인 영역 */}
      <div className="flex gap-5 h-[700px]">
        {/* 왼쪽: 4DSimulation 트리 */}
        <div className="w-1/3 min-w-[280px] border rounded-2xl p-4 shadow-sm bg-white flex flex-col">
          <div className="mb-3">
            <h3 className="font-semibold text-gray-900">
              4D 시뮬레이션 파일 트리
            </h3>
            <p className="mt-1 text-xs text-gray-500">
              자료실의 <span className="font-semibold">4DSimulation</span> 폴더
              하위 중, <span className="font-mono">.gltf</span> 파일만
              표시됩니다. 파일을 선택하면 우측에서 4D/3D로 확인할 수 있습니다.
            </p>
          </div>

          <div className="flex-1 overflow-y-auto pt-1">
            <FileTreePanel
              selectionMode="single"
              rootFolderName="4DSimulation"
              title=""
              fileExtensionFilter={["gltf"]}
              onPick={(file) => {
                // file: 자료실 파일 객체 (file.file = URL 가정)
                setSelectedFourD({
                  gltfUrl: file.file,
                  name: file.name,
                });
              }}
              // 여기서는 폴더 선택은 업로드 대상이 아니라서 굳이 안 써도 됨
              onFolderSelect={() => {}}
            />
          </div>
        </div>

        {/* 오른쪽: 뷰어 영역 */}
        <div className="flex-1 border rounded-2xl p-4 shadow-sm bg-white relative h-[650px] flex flex-col">
          <div className="mb-3 flex items-center justify-between">
            <div>
              <h3 className="font-semibold text-gray-900">
                {viewMode === "simulation"
                  ? "4D 시뮬레이션 뷰어"
                  : "3D 모델 뷰어"}
              </h3>
              {selectedFourD && (
                <p className="mt-1 text-xs text-gray-500">
                  선택된 파일:{" "}
                  <span className="font-medium">{selectedFourD.name}</span>
                </p>
              )}
            </div>
            <span className="text-xs text-gray-500">
              {selectedFourD
                ? "마우스를 이용해 회전 / 확대 / 축소할 수 있습니다."
                : "좌측 트리에서 glTF 파일을 선택하세요."}
            </span>
          </div>

          <div className="flex-1 relative rounded-xl bg-gray-100 overflow-hidden">
            {selectedFourD ? (
              viewMode === "simulation" ? (
                <ThreeViewerWithTimeline gltfUrl={selectedFourD.gltfUrl} />
              ) : (
                <ThreeViewer gltfUrl={selectedFourD.gltfUrl} />
              )
            ) : (
              <div className="w-full h-full flex items-center justify-center">
                <p className="text-sm text-gray-500">
                  좌측에서 glTF 파일을 선택하면 이 영역에 4D/3D 뷰어가
                  표시됩니다.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Project4DPage;
